export default __webpack_public_path__ + "static/media/loader.8592b707.gif";